// @flow
import * as React from 'react';
import { StyledSelect } from 'components/Select';
import {
  // $FlowFixMe: flow and react-select seem to have issues
  components
} from 'react-select';
import Box from 'components/Box';
import ClientOnly from 'containers/ClientOnly';
import { colors } from 'theme';

const COLOR_MAP = {
  NEW: {
    bg: colors.waterBlue,
    color: 'white'
  },
  YES: {
    bg: colors.turtleGreen,
    color: 'white'
  },
  NO: {
    bg: colors.silver,
    color: colors.charcoalGrey
  },
  MAYBE: {
    bg: colors.dandelion,
    color: colors.charcoalGrey
  }
};

const getColor = key => COLOR_MAP[key] || COLOR_MAP.NEW;

const Label = ({ value, ...props }: { value: string }) => (
  <Box
    data-qa-id="listing-status"
    display="block"
    py="4px"
    px="8px"
    borderRadius="4px"
    letterSpacing="1px"
    textTransform="uppercase"
    lineHeight={1}
    fontSize={12}
    {...getColor(value)}
    {...props}
  />
);

const SingleValue = (props: {
  getValue: () => Array<{ value: string, label: string }>
}) => {
  const { value, label } = props.getValue()[0];
  return (
    <components.SingleValue {...props}>
      <Label value={value}>{label}</Label>
    </components.SingleValue>
  );
};

const Option = (props: { value: string, label: string }) => (
  <components.Option {...props}>
    <Label value={props.value}>{props.label}</Label>
  </components.Option>
);

const StatusSelect = ({
  name,
  label,
  value,
  options,
  disabled,
  onChange,
  className,
  ...props
}: {
  name?: string,
  label?: React.Node,
  value: ?string,
  options: Array<{ value: string, label: string }>,
  disabled?: boolean,
  onChange?: Function,
  className?: string,
  'data-qa-id'?: string
}) => {
  const classNames = props['data-qa-id'] ? [props['data-qa-id']] : [];
  if (className) {
    classNames.push(className);
  }

  const Container = label ? 'label' : React.Fragment;

  return (
    <ClientOnly>
      <Container>
        {label && <Box display="none">{label}</Box>}
        <StyledSelect
          name={name}
          options={options}
          value={options.filter(({ value: v }) => v === value)}
          isDisabled={disabled}
          onChange={onChange}
          isSearchable={false}
          isClearable={false}
          className={classNames.join(' ')}
          components={{ Option, SingleValue }}
          {...props}
        />
      </Container>
    </ClientOnly>
  );
};

export default StatusSelect;
